var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.2129 6.30844C31.9778 6.85022 30.6617 7.20933 29.2896 7.3837C30.7012 6.54093 31.7785 5.21656 32.285 3.62027C30.969 4.40492 29.5159 4.95916 27.9673 5.26846C26.7177 3.93786 24.9367 3.11377 22.9937 3.11377C19.224 3.11377 16.1892 6.17351 16.1892 9.92449C16.1892 10.4642 16.2349 10.9832 16.347 11.4772C10.6863 11.2011 5.67733 8.48803 2.31245 4.3551C1.725 5.37432 1.38041 6.54093 1.38041 7.79679C1.38041 10.1549 2.59476 12.2452 4.40486 13.4554C3.31091 13.4347 2.23772 13.1171 1.32852 12.6168C1.32852 12.6376 1.32852 12.6646 1.32852 12.6915C1.32852 16.0004 3.68871 18.7487 6.78373 19.3819C6.22949 19.5334 5.62544 19.606 4.99854 19.606C4.56262 19.606 4.12255 19.5811 3.70947 19.4898C4.59168 22.1863 7.09511 24.1687 10.0718 24.233C7.75521 26.0452 4.8138 27.1371 1.62951 27.1371C1.07112 27.1371 0.535558 27.1122 0 27.0437C3.01615 28.9887 6.59069 30.0992 10.4455 30.0992C22.975 30.0992 29.8252 19.7202 29.8252 10.7237C29.8252 10.4227 29.8148 10.1321 29.8003 9.84353C31.1516 8.88451 32.2871 7.68677 33.2129 6.30844Z",
    fill: "inherit"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.2129,
    height: 33.2129,
    fill: "inherit"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.51cb12d9.svg";
export { ForwardRef as ReactComponent };